import type {Collection} from 'api/types';
import type {Schemas} from 'api/dto.generated';
import {
  mapGetCollectionDto,
  mapToUpsertCollectionDto,
} from 'api/mappers/mapCollectionDto';
import {ebsApi} from 'store/ebsApi';

const seriesApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getSeries: build.query<
      Collection,
      Pick<Collection, 'id'>,
      Schemas.SeriesWithRelationsDto
    >({
      keepUnusedDataFor: 60,
      query: ({id}) => ({
        url: `series/${id}`,
      }),
      transformResponse: mapGetCollectionDto,
      providesTags: (_, __, {id}) => [{type: 'Series', id}],
    }),

    mergeSeries: build.mutation<
      void,
      {target: Collection; source: Pick<Collection, 'id'>}
    >({
      query: ({target, source}) => ({
        url: `series/${target.id}/merge/${source.id}`,
        method: 'PUT',
        body: mapToUpsertCollectionDto(target),
      }),
      invalidatesTags: (_, __, {target, source}) => [
        {type: 'Series', id: target.id},
        {type: 'Series', id: source.id},
      ],
    }),
  }),
});

export const {useGetSeriesQuery, useMergeSeriesMutation} = seriesApi;
